import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
// import { axiosInstnace as Axios } from "../../util/util";
// import { endPoints } from "../../config";

const DSATermsPopup = (props) => {
  const closePopup = () => {
    props.hide();
  };
  const handleSubmit = () => {
    props.acceptterms();
  };

  //Return the popup for approve request
  return props.isShowing ? (
    <div>
      <div className="modal-overlay">
        <div
          className="modal-wrapper thankyou-popup"
          aria-modal
          aria-hidden
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal approval" style={{ width: "125%" }}>
            <div className="modal-head-cross rate-modal">
              <button
                type="button"
                className="modal-close-button"
                onClick={closePopup}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="editNonFct-header modal-header">
                <h4 className="popup-head rqst-head fct-head modal-title">
                  DIGITAL TERMS AND CONDITIONS
                </h4>
              </div>
              <div className="approval-content modal-body">
                <div
                  className="popup-container reqst-rejection"
                  style={{ height: "75vh", overflow: "auto" }}
                >
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    This Agreement in the form of terms and conditions
                    constitutes a legally binding agreement made between you,
                    whether personally or on behalf of an entity (&ldquo;
                    <strong>You</strong>&rdquo;) and Reliance Broadcast Network
                    Limited (&ldquo;
                    <strong>we</strong>,&rdquo; &ldquo;<strong>us</strong>
                    &rdquo; or &ldquo;<strong>our</strong>&rdquo;), concerning
                    your access to and use of the{" "}
                    <a target="_blank" href="https://buyadsonbigfm.com/">
                      buyadsonbigfm.com
                    </a>{" "}
                    website as well as any other media form, media channel,
                    mobile website or mobile application related, linked, or
                    otherwise connected thereto (collectively, the &ldquo;
                    <strong>Site/Website</strong>&rdquo;).
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Our website -{" "}
                    <a target="_blank" href="https://buyadsonbigfm.com/">
                      buyadsonbigfm.com
                    </a>{" "}
                    is a platform that will help advertisers make requests for
                    jingles, strategize media plans, place orders and transact
                    online. With regular and timely upgrades, the website has an
                    easy-to-use interface that enhances the customer experience.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    You agree that by accessing the Site, You have read,
                    understood, and thereby agree to be bound by all of these
                    Terms and Conditions. If You do not agree with all of these
                    Terms and Conditions, then You are expressly prohibited from
                    using the Site and you must discontinue use immediately.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Supplemental terms and conditions or documents that may be
                    posted on the Site from time to time are hereby expressly
                    incorporated herein by reference. We reserve the right, in
                    our sole discretion, to make changes or modifications to
                    these Terms and Conditions at any time and for any reason.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    We shall intimate You of any changes by updating the
                    &ldquo;Last updated&rdquo; date of these Terms and
                    Conditions, and You waive any right to receive specific
                    notice of such change.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    It is your responsibility to periodically review these Terms
                    and Conditions to stay informed of any updates. You will be
                    subject to, and will be deemed to have been made aware of
                    and to have accepted, the changes in any revised Terms and
                    Conditions by your continued use of the Site after the date
                    such revised Terms and Conditions are posted.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    The information provided on the Site is not intended for
                    distribution to or use by any person or entity in any
                    jurisdiction or country where such distribution or use would
                    be contrary to law or regulation or which would subject us
                    to any registration requirement within such jurisdiction or
                    country.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Accordingly, those persons who choose to access the Site
                    from other locations do so on their own initiative and are
                    solely responsible for compliance with local laws, if and to
                    the extent local laws are applicable.&nbsp;
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    This Master Sales Agreement is made and entered into and
                    agreed upon by you, either an individual or an entity, and
                    any associated affiliates (&ldquo;<strong>You</strong>
                    &rdquo;) and Reliance Broadcast Network Limited (&ldquo;
                    <strong>Company</strong>&rdquo;) for advertisers/agencies to
                    buy ad-spots to broadcast their content on the radio channel
                    owned by the Company subject to such conditions as are set
                    out hereinbelow.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    The Company and You are hereinafter jointly referred to as
                    &ldquo;<strong>Parties</strong>&rdquo; and individually as
                    &ldquo;<strong>Party</strong>&rdquo;.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    <strong>
                      NOW, THEREFORE THE PARTIES HERETO INTENDING TO BE LEGALLY
                      BOUND IN CONSIDERATION OF MUTUAL AGREEMENTS AND COVENANTS
                      CONTAINED HEREIN DO HEREBY AGREE AS FOLLOWS:
                    </strong>
                  </p>
                  <ol
                    style={{
                      fontSize: "14px",
                      textAlign: "justify",
                      marginLeft: "35px",
                      marginTop: "15px",
                      marginRight: "10px",
                    }}
                  >
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      Definitions:
                      <ol
                        style={{
                          marginLeft: "35px",
                          marginTop: "15px",
                        }}
                      >
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          &ldquo;<strong>Advertiser</strong>&rdquo; shall mean a
                          person, firm, company, or any other organization whose
                          products, goods or services are the subject matter of
                          the Advertising Copy for payment of the Advertising
                          Fee under this Agreement.
                        </li>
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          &ldquo;<strong>Advertising Copy</strong>&rdquo; shall
                          mean any advertising material and content proposed to
                          be included in any advertisement to be supplied by
                          &ldquo;You&rdquo; and/or produced by Company for
                          broadcast on the Station.
                        </li>
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          &ldquo;<strong>Advertising Fee</strong>&rdquo; shall
                          have the meaning set out in the individual Deal
                          Agreements/Release Order which shall form an integral
                          part of the Agreement.
                        </li>
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          &ldquo;<strong>Agreement</strong>&rdquo; shall mean
                          the Deal Agreement/Release Order (&ldquo;RO&rdquo;)
                          together with these Standard Terms and Conditions and
                          all annexures hereto and shall include all
                          modifications, alterations, additions or deletions
                          thereto agreed between the Parties in writing after
                          the date of this Agreement.
                        </li>
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          &ldquo;<strong>Deal Agreement/Release Order</strong>
                          &rdquo; shall mean individual deals which shall be
                          signed in addition to this Agreement.
                        </li>
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          &ldquo;<strong>Station</strong>&rdquo; shall mean the
                          radio station/s operated by the Company, its
                          affiliates and/or licensors operated under the
                          licenses obtained from the Government of India and
                          specified in the Deal Agreement.
                        </li>
                      </ol>
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      RO’s for campaigns booked till 18:00 hours on a business
                      day shall be eligible to be broadcasted on the radio
                      station(s) from next day. However, Release Orders booked
                      after 18:00 hours on a particular day shall be broadcasted
                      on the day after the next working day of booking such
                      Release Orders.
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      {" "}
                      RO’s once released are non-cancellable and shall not be
                      eligible to be postponed. The Company has all rights to
                      defer the playout of RO to future date.
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      You shall furnish relevant details in the Know Your
                      Customer (<strong>&ldquo;KYC&rdquo;</strong>) made
                      available on the Website, duly filled to the Company. You
                      shall be responsible to intimate the Company of any
                      changes in the details of KYCF provided as soon as such
                      changes become occur and are effective. Though inserting
                      the GST details of the Agency/ Advertiser is not
                      mandatory, Agency/ Advertiser shall note that they will
                      not be eligible for GST ITC if they choose to not furnish
                      such details in the KYCF screen. You hereby represent and
                      warrant that any and all information provided by You,
                      before, during and after execution of this Agreement is
                      true to the best of your knowledge and belied and that you
                      have not intentionally withheld information or furnished
                      false information for any reason whatsoever.
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      You acknowledge that any damage or loss suffered by You or
                      the Company due to false information published by You
                      shall be your sole liability and You shall keep the
                      Company indemnified and harmless against any claim, cost
                      or damages arising out of the same.
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      You shall:
                      <ol
                        style={{
                          marginLeft: "35px",
                          marginTop: "15px",
                        }}
                      >
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          only be entitled to the advertising spots and/or
                          sponsorships or other deliverables as specified in the
                          Deal Agreements/Release Order;{" "}
                        </li>
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          Each RO should mention the following details :-
                          <ol
                            style={{
                              marginLeft: "35px",
                              marginTop: "15px",
                            }}
                          >
                            <li
                              style={{
                                listStyle: "lower-roman",
                                marginBottom: "10px",
                              }}
                            >
                              GST number and corresponding address of Agency
                              and/or Advertiser; if any;
                            </li>
                            <li
                              style={{
                                listStyle: "lower-roman",
                                marginBottom: "10px",
                              }}
                            >
                              GST number and address of Company location to
                              which RO is issued; if any.{" "}
                            </li>
                            <li
                              style={{
                                listStyle: "none",
                                marginBottom: "10px",
                              }}
                            >
                              The RO incorporating the above said details shall
                              be used for billing.
                            </li>
                          </ol>
                        </li>
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          Ensure that materials carrying advertising copy or any
                          other material approved by the Company are provided at
                          least 48 (forty-eight) working hours prior to the date
                          of airing the first spot, failing which the Company is
                          not obliged to book and/or air those spots;{" "}
                        </li>
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          Ensure that the materials carrying the advertising
                          copy shall satisfy the Standards & Practices,
                          Compliance and Quality Check by the Company. In the
                          event that the advertising copy does not adhere to the
                          Standards & Practices, Compliance and Quality Check,
                          the Company reserves the right to refuse transmission
                          of any advertisement, without giving any reason and
                          without incurring any liability towards the You. In
                          such event the You shall not be liable to pay for
                          advertisements which are not aired;{" "}
                        </li>
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          Agree that Run of Schedule (ROS) / Run of Day Part
                          (RODP) / frequency builder spots can appear in any
                          part of the day within the specified time band on a
                          best effort basis.{" "}
                        </li>
                      </ol>
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      The Deliverables mentioned in the Deal Agreements/Release
                      Order shall be performed subject to inventory being
                      available with the Company and such Deliverables contained
                      in the Deal Agreements/Release Order may be altered from
                      time to time to accommodate live broadcasts or special
                      events and this shall be mutually discussed between the
                      Parties in advance. In such event programming/delivery of
                      Deliverables will be differently priced from regular rates
                      or time-band previously schedule.
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      You agree that the Company may internally allocate the
                      total cost, i.e. breakup between sponsorship, spot buys
                      and others whilst keeping the total cost and
                      secondage/sponsorship, intact.
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      In accordance with the Company’s policies, You may
                      reschedule the booking commitments may by writing to
                      “rochanges@radiobigfm.com” at least 48 (forty-eight)
                      working hours prior to the date of airing of the spots. In
                      case the revised schedule is received within 24
                      (twenty-four) hours of airing of spots, Company will
                      execute the revision on best effort basis.
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      Payment Terms:{" "}
                      <ol
                        style={{
                          marginLeft: "35px",
                          marginTop: "15px",
                        }}
                      >
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          The Payments for the RO and campaign shall be made by
                          You in advance. The same can be effected in the
                          following manner:
                          <ol
                            style={{
                              marginLeft: "35px",
                              marginTop: "15px",
                            }}
                          >
                            <li
                              style={{
                                listStyle: "lower-roman",
                                marginBottom: "10px",
                              }}
                            >
                              In case the advertisement creatives are provided
                              by You – payment for the same shall be made in
                              advance. The creatives so provided shall be
                              broadcast post approval of the said creative from
                              the Company;
                            </li>

                            <li
                              style={{
                                listStyle: "lower-roman",
                                marginBottom: "10px",
                              }}
                            >
                              In case You require the Company to deliver
                              creatives for the advertisement, payment for the
                              same shall be divided basis:
                              <ol
                                style={{
                                  marginLeft: "35px",
                                  marginTop: "15px",
                                }}
                              >
                                <li
                                  style={{
                                    listStyle: "decimal",
                                    marginBottom: "10px",
                                  }}
                                >
                                  Payment for creatives as per the chosen
                                  package; and
                                </li>
                                <li
                                  style={{
                                    listStyle: "decimal",
                                    marginBottom: "10px",
                                  }}
                                >
                                  After delivery by the Company and approval of
                                  the creative by You, the remaining amount for
                                  the broadcast of such creatives.
                                </li>
                              </ol>
                            </li>
                          </ol>
                        </li>
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          For the creatives as specified in 10. a. ii. above,
                          the advertisement will be broadcasted only after the
                          confirmation and receipt by the Company of complete
                          payment/s made by You.
                        </li>
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          Any and all payments made by You shall be
                          non-refundable unless as otherwise mentioned in the
                          Agreement.{" "}
                        </li>
                      </ol>
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      All creatives created and provided by the Company shall be
                      the exclusive property of the Company and as such, the
                      Company shall be exclusive owner of all Intellectual
                      Property Rights with respect to such creatives.
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      Both Parties represent and warrant to have the requisite
                      right, power and authority necessary to enter into this
                      Agreement and that this Agreement shall be legally binding
                      on all/both Parties.{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      You hereby warrant, represent, and undertake to the
                      Company that:
                      <ol
                        style={{
                          marginLeft: "35px",
                          marginTop: "15px",
                        }}
                      >
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          You have obtained, and paid for, all necessary
                          consents, licenses and permissions for the inclusion
                          of all audio material in the Advertising Copy and the
                          transmission of the Advertising Copy;
                        </li>
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          The content of the advertisements and/ or spots
                          provided to the Company for broadcast shall be in
                          conformity with all applicable laws prevailing in
                          India and especially the Advertisement Code and the
                          Standards of practices issued by the Advertising
                          Standards Council of India (ASCI) and All India Radio
                          Commercial Advertisement Code and have been duly
                          censored by the appropriate authority, if required;{" "}
                        </li>

                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          The content and the campaign is not aimed at inciting
                          any kind of communal disharmony or an attempt to
                          destroy the peaceful bond and friendship amongst
                          different communities or any other action / intention
                          that are against the existing governing laws in India;
                        </li>
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          Nothing contained in the advertisement/s, Program
                          directly or indirectly infringes the copyright or any
                          other right of any third party and that there are no
                          claims, actions or proceedings, pending or threatened,
                          affecting the advertisement or the title thereof;
                        </li>
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          You will fully indemnify and keep the Company and its
                          respective affiliates and licensors fully indemnified
                          against all actions, proceedings, costs, damages,
                          expenses, penalties, claims, demands and liabilities
                          howsoever arising from any breach of its warranties,
                          obligations or terms contained in this Agreement or in
                          any manner whatsoever as a consequence of the use,
                          recording transmission or broadcasting in the form
                          submitted or prescribed of any Advertising Copy or
                          matter supplied by or transmitted for You, or any
                          third party claim;
                        </li>

                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          You grant the Company the right to make recordings of
                          all the content provided to the Company by You for the
                          Company’s archives and to enable the Company to submit
                          a copy of the same to any statutory authority in order
                          to comply with the provisions of all applicable laws;{" "}
                        </li>
                        <li
                          style={{
                            listStyle: "lower-alpha",
                            marginBottom: "10px",
                          }}
                        >
                          You shall not hold the Company responsible for any
                          product/ service liability of any kind. It is
                          clarified that Company is a mere broadcaster of
                          Advertisements.
                        </li>
                      </ol>
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>

                    You hereby grant to the Company, the non-exclusive
                          right to use your logos, trade names and trademarks in
                          the performance of its obligations during the term of
                          this Agreement and in the Company’s advertising sales
                          marketing materials. You represent and warrant that
                          You have the authority to grant such rights.
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                    You hereby agree to hold and continue to hold the
                          Company, its officers, employees fully indemnified
                          without any limit against any claim, cost, expenses,
                          damages and/ or penalty that the Company may suffer on
                          account of the telecasting/ airing of the Advertising
                          Material and/ or the program and against any claims or
                          proven actual loss that may be suffered due to false
                          product claims or any other non-compliance to
                          applicable laws.

                    </li>

                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      The Parties agree to keep the terms of this
                      Agreement strictly confidential. Except to the extent
                      authorized by this Agreement and any requirement under
                      law, during the term and following the expiration or
                      termination of the agreement, the parties shall not
                      disclose, publish or make available any proprietary
                      information including but not limited to rates, time
                      bands, costs etc. to any third party and shall not sell,
                      transfer or otherwise use or exploit any such Proprietary
                      information disclosed to them.
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      No Party shall be liable to any other for any loss of
                      business, revenue, or profits, or any indirect or
                      consequential loss or damage whatsoever arising out of or
                      in connection with the performance or non-performance of
                      this Agreement.{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      You shall not assign, delegate, or license your rights in
                      whole or in part under this Agreement without the prior
                      written consent of the Company. The Company may assign,
                      delegate or license its rights and obligations under this
                      Agreement at any time.{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      The Company shall not be liable for damages for any delay
                      or failure to perform its obligations hereunder, if such
                      delay or failure is due to causes beyond its control and
                      without its negligence, including, without limitation,
                      acts of God or state or of any sovereign authority or any
                      public enemy, or acts mandated by any applicable laws,
                      regulation or order (whether valid or invalid) of any
                      governmental body/ ministry/ authority.
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>If You provide an advertisement which, in the Company’s reasonable opinion, violates any laws or regulations in force at the relevant time, including, without limitation, advertisements which are against public interest, public sentiment or tantamount to unfair, monopolistic or restrictive trade practices, then the Company reserves the right upon written notice / verbal notice / without notice to You to: (i) withdraw any such advertisement from broadcast, (ii) ask You to replace any such advertisement, and/or (iii) terminate this Agreement immediately upon written notice.</li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      This Agreement and the rights and obligations of the
                      Parties hereunder shall be construed, interpreted, and
                      enforced in accordance and governed by the existing laws
                      of India.
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      In the event of any claims, disputes, questions, involving
                      the Parties and arising out of or in connection with this
                      Agreement, or the execution, interpretation, validity,
                      performance breach or termination hereof shall be resolved
                      by the Parties amicably as far as possible between the
                      duly authorized representatives of the Parties hereto
                      within 30 (thirty) calendar days of arising thereof. If
                      the Parties fail to arrive at an amicable resolution, the
                      Courts of Mumbai shall have exclusive jurisdiction over
                      such claims, disputes and/or questions.
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      This Agreement does not create any partnership or agency
                      relationship between the Company and You, and neither the
                      Company, nor You shall be entitled to act as the other’s
                      agent or represent or hold itself out in any way as
                      representing or acting on behalf of the other unless such
                      representation or action is specifically authorized in and
                      voice in writing by the other.
                    </li>
                  </ol>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    By clicking on “I Agree” button below, You hereby waive any and all defenses you may have based on
                    the electronic form of these Terms and Conditions and the
                    lack of signing by the Parties hereto to execute in
                    Agreement setting out the Terms and Conditions.
                  </p>
                  <div className="confirn-btn">
                    <button className="cancel-reqst" onClick={props.hide}>
                      Decline
                    </button>
                    <button className="confirm-reqst" onClick={handleSubmit}>
                      I Agree
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default DSATermsPopup;



// WEBPACK FOOTER //
// ./web/components/common/terms.js